import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { LINK_SURVEYS_GUIDE } from 'shared/constants/links'
import { uiStore } from 'shared/store/uiStore'
import { SurveysPath } from 'entities/ExportRouters'

export const NewSurveyButton = observer(({ className }: { className?: string }) => {
  return (
    <Button
      text='New survey'
      size='medium'
      iconProps={{ icon: 'add' }}
      onClick={() => uiStore.changeRoute({ path: `${SurveysPath.create}` })}
      className={className}
    />
  )
})

export const GuideButton = observer(({ className }: { className?: string }) => (
  <Button
    className={className}
    tag={'a'}
    href={LINK_SURVEYS_GUIDE}
    text='Help guide'
    target='_blank'
    rel='noreferrer'
    size='medium'
    contained='secondary'
    iconProps={{ icon: 'info' }}
  />
))
